import Client from "./client";

/**
 * A project's API keys - the credentials a tool outside the browser uses
 * against /api/v1. This module only makes and unmakes them.
 */

export const GetProjectApiKeys = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/api-keys`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.apiKeys);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong fetching the API keys. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

/**
 * Creates a key, and resolves with `{apiKey, key}`.
 *
 * `key` is the only time the key itself is ever sent - the server keeps only
 * its hash, so there is no reading it back afterwards. Whatever shows it has
 * one chance to.
 *
 * `status` rides along on a rejection so a 402 (not on this plan) can be told
 * from an ordinary failure - the same thing GetProjectDetails does.
 */
export const CreateProjectApiKey = ({projectId, name, access, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/api-keys`, {name, access}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong creating the API key. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

// Ends a key immediately. Not plan-gated on the server, on purpose: a project
// that has dropped off Pro still has to be able to clean up after itself.
export const RevokeProjectApiKey = ({keyId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/api-keys/${keyId}/revoke`, {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.apiKey);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong revoking the API key. Please try again." });
        })
    })
}
